import React from 'react';
import classNames from './SingleOriginFilterView.module.css'
import { AllOption, AllThirdPartiesOption, SingleOriginFilterState } from './SingleOriginFilterState';
import { observer } from 'mobx-react-lite';

export const OptionsAllOrArray = ({options, allLabel="all", allThirdPartiesLabel}: {options: string[], allLabel?: string, allThirdPartiesLabel?: string}) => (
	<>
		<option className={AllOption} key={AllOption} value={AllOption}>{allLabel}</option>
		{
			allThirdPartiesLabel ?
				<option className={AllOption} key={AllThirdPartiesOption} value={AllThirdPartiesOption}>{allThirdPartiesLabel}</option> :
				null
		}
		{
			options.map( option => (
				<option key={option} value={option}>{option}</option>
			))
		}
	</>);



		{/* <button onClick={ () => singleOriginFilterState.setSortBy('chronological') }>🕒</button>
		<button onClick={ () => singleOriginFilterState.setSortBy('alphanumeric') }>🔤</button>
		<button onClick={ () => singleOriginFilterState.setSortDirection('ascending') }>⬇️</button>
		<button onClick={ () => singleOriginFilterState.setSortDirection('descending') }>⬆️</button> */}

export const SingleOriginFilterView = observer( ({singleOriginFilterState, label}: {
	singleOriginFilterState: SingleOriginFilterState;
	label: string;
}) => {
	return (
		<div className={classNames.FilterRowContainer}>
			<label>{label}</label>
			<select className={classNames.RegisteredDomainFilterSelectedElement}
				hidden={ singleOriginFilterState.registeredDomains.length < 1 }
				disabled={ singleOriginFilterState.registeredDomains.length < 2 }
				value={ singleOriginFilterState.registeredDomains.length === 1 ?
					singleOriginFilterState.registeredDomains[0] :
					singleOriginFilterState.registeredDomainSelected
				}
				onChange={ e => singleOriginFilterState.setDomainOrUrlToFilterFor(e.currentTarget.value)}
			>
				<OptionsAllOrArray 
					options={singleOriginFilterState.registeredDomains}
					allLabel='all registered domains'
					allThirdPartiesLabel={ singleOriginFilterState.supportsFilteringByThirdParties ? 'all third parties' : undefined }	
				/>
			</select>
			<select className={classNames.DomainFilterSelectedElement}
				hidden={ singleOriginFilterState.filteredDomains.length < 1 }
				disabled={ singleOriginFilterState.filteredDomains.length < 2 }
				value={ singleOriginFilterState.filteredDomains.length === 1 ?
					singleOriginFilterState.filteredDomains[0] :
					singleOriginFilterState.domainSelected
				}
				onChange={ e => singleOriginFilterState.setDomainOrUrlToFilterFor(e.currentTarget.value)}
			>
				<OptionsAllOrArray options={singleOriginFilterState.filteredDomains} allLabel='all domains' />
			</select>
			<select className={classNames.URLFilterSelectedElement}
				hidden={ singleOriginFilterState.filteredUrls.length < 1 }
				disabled={ singleOriginFilterState.filteredUrls.length < 2 }
				value={ singleOriginFilterState.filteredUrls.length === 1 ?
					singleOriginFilterState.filteredUrls[0] :
					singleOriginFilterState.urlSelected
				}
				onChange={ e => singleOriginFilterState.setDomainOrUrlToFilterFor(e.currentTarget.value)}
			>
				<OptionsAllOrArray options={singleOriginFilterState.filteredUrls} allLabel='all URLs' />
			</select>
		</div>
	)
});